import { utilities } from 'dcmjs';
import MeasurementReport from './MeasurementReport';
import BaseAdapter3D from './BaseAdapter3D';
import { toScoords } from '../helpers';

const { CobbAngle: TID300CobbAngle } = utilities.TID300;

class CobbAngle extends BaseAdapter3D {
  static {
    this.init('CobbAngle', TID300CobbAngle);
    // Register using the Cornerstone 1.x name so this tool is used to load it
    this.registerLegacy();
  }

  // TODO: this function is required for all Cornerstone Tool Adapters, since it is called by MeasurementReport.
  public static getMeasurementData(
    MeasurementGroup,
    sopInstanceUIDToImageIdMap,
    metadata
  ) {
    const {
      state,
      NUMGroup,
      referencedImageId,
      worldCoords,
      ReferencedFrameNumber,
    } = MeasurementReport.getSetupMeasurementData(
      MeasurementGroup,
      sopInstanceUIDToImageIdMap,
      metadata,
      CobbAngle.toolType
    );

    state.annotation.data = {
      ...state.annotation.data,
      handles: {
        ...state.annotation.data.handles,
        points: [
          worldCoords[0],
          worldCoords[1],
          worldCoords[2],
          worldCoords[3],
        ],
      },
      frameNumber: ReferencedFrameNumber,
    };
    if (referencedImageId) {
      state.annotation.data.cachedStats = {
        [`imageId:${referencedImageId}`]: {
          angle: NUMGroup ? NUMGroup.MeasuredValueSequence.NumericValue : null,
        },
      };
    }

    return state;
  }

  public static getTID300RepresentationArguments(
    tool,
    is3DMeasurement = false
  ) {
    const { data, finding, findingSites, metadata } = tool;
    const { cachedStats = {}, handles } = data;

    const { referencedImageId } = metadata;
    const scoordProps = {
      is3DMeasurement,
      referencedImageId,
    };
    const points = toScoords(scoordProps, handles.points);

    // Using image coordinates for 2D points
    const [point1, point2, point3, point4] = points;

    const { angle } = cachedStats[`imageId:${referencedImageId}`] || {};

    return {
      point1,
      point2,
      point3,
      point4,
      rAngle: angle,
      trackingIdentifierTextValue: this.trackingIdentifierTextValue,
      finding,
      findingSites: findingSites || [],
      ReferencedFrameOfReferenceUID: is3DMeasurement
        ? metadata.FrameOfReferenceUID
        : null,
      use3DSpatialCoordinates: is3DMeasurement,
    };
  }
}

export default CobbAngle;
